import { Box, Card, CardContent, Skeleton } from '@mui/material';

const BotelCardSkeleton = () => {
  return (
    <Card sx={{ maxWidth: 345, height: '100%' }}>
      <Skeleton variant="rectangular" height={200} />
      <CardContent>
        <Skeleton variant="text" width="80%" height={32} />
        <Box sx={{ mt: 2 }}>
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="50%" />
        </Box>
      </CardContent>
    </Card>
  );
};

export default BotelCardSkeleton; 